import { render, staticRenderFns } from "./shouyePie2Echart.vue?vue&type=template&id=6b2d031c&scoped=true&"
import script from "./shouyePie2Echart.vue?vue&type=script&lang=js&"
export * from "./shouyePie2Echart.vue?vue&type=script&lang=js&"
import style0 from "./shouyePie2Echart.vue?vue&type=style&index=0&id=6b2d031c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d031c",
  null
  
)

export default component.exports